import { type ReactNode, useState } from 'react';
import cx from 'clsx';
import { PdfPreview } from '@repo/domain-kit/invoices';
import type { Client, Merchant, DocumentType, Document } from '../types';
import styles from '../responsive-view.module.css';

interface PdfSectionProps {
  document: Document;
  client?: Client;
  merchant: Merchant;
  documentType: DocumentType;
}

export function PdfSection({
  document,
  client,
  merchant,
  documentType,
}: PdfSectionProps): ReactNode {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  if (document.pdfSrc) {
    return (
      <div className={styles.pdfPreview} data-testid="pdf-section-iframe-container">
        <iframe
          className={cx(styles.iframe, !isIframeLoaded && styles.hidden)}
          data-test-pdf-iframe
          data-testid="pdf-section-iframe"
          onLoad={() => {
            setIsIframeLoaded(true);
          }}
          src={`${document.pdfSrc}#toolbar=0&view=Fit`}
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx -- title required for iframe
          title="pdf-preview"
        />
      </div>
    );
  }

  return (
    <div data-testid="pdf-section-preview-container">
      <PdfPreview
        client={client}
        document={document}
        logo={undefined}
        merchant={merchant}
        relatedInvoice={document.originalInvoice}
        type={documentType}
        variant={merchant.legalCountry}
      />
    </div>
  );
}
